import { CacheAreaKey } from 'core/config/cache-config';
import { StorageHelper } from 'core/services/storage';
import { PaymentSession } from 'payment/payment.context';

const usePaymentSessionOptions = () => {
  const key = 'sessions';
  const areaKey = CacheAreaKey.Payments;

  const get = () => {
    const paymentSession = StorageHelper
      .GetInstance
      .getFromCache(key, 'create', areaKey) as PaymentSession;
    return paymentSession ?? {};
  }

  const clear = () => {
    StorageHelper.GetInstance.removeFromStorage(key, areaKey);
  }

  return { get, clear };
}

const usePaymentSession = () => {
  const { get } = usePaymentSessionOptions();
  return get();
}

export const useClearPaymentSession = () => {
  const { clear } = usePaymentSessionOptions();
  return clear;
}

export default usePaymentSession;